var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('van-dialog',{attrs:{"title":"标题","show-cancel-button":""},model:{value:(_vm.show),callback:function ($$v) {_vm.show=$$v},expression:"show"}},[_c('img',{staticClass:"c-w-20",attrs:{"src":"https://img01.yzcdn.cn/vant/apple-3.jpg"}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }